import classNames from 'classnames'
import React from 'react'
import styles from './sideNavItem.module.scss'

type ConditionalProps =
  | { external: true; onClick?: never; href: string }
  | { external?: false; onClick: () => void; href?: never }

interface Props {
  icon: React.ReactNode
  copy: string
  active?: boolean
}

export type SideNavItemProps = Props & ConditionalProps

const SideNavItem = ({ icon, copy, active, onClick, external, href }: SideNavItemProps) => {
  const Element = external ? 'a' : 'button'

  return (
    <Element
      className={classNames(styles.navItem, {
        [styles.anchor]: external,
        [styles.active]: active,
      })}
      onClick={external ? undefined : onClick}
      href={external ? href : undefined}
    >
      <span className={styles.content}>
        <span className={styles.icon}>{icon}</span>
        <span className={styles.text}>{copy}</span>
      </span>
    </Element>
  )
}

export default SideNavItem
